<!--
 * @Author: wangzhisong
 * @Date: 2022-08-18 09:36:05
 * @LastEditTime: 2022-08-23 15:59:12
 * @FilePath: \smart-community\src\views\monitorManagement\keyControl\components\drugrighzero.vue
-->
<template>
  <div id="drugrightzero">
    <div class="content-item">
      <h-icon icon="icon-caidan" class="icon" style="color:#03fafb"></h-icon>
      <div class="content-desc">
        <div>抓拍总量</div>
        <div>{{ count }}</div>
      </div>
    </div>
    <div class="content-item">
      <h-icon icon="icon-weizhi" class="icon" style="color:#03fafb"></h-icon>
      <div class="content-desc">
        <div>抓拍人数</div>
        <div>{{ personCount }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watchEffect,
  inject,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import { totalCount, totalPersonNum } from "@/api/monitorManagement/keyControl.js";
export default defineComponent({
  name: "drugrightzero",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      count: 0,
      personCount: 0,
    });
    const refData = toRefs(data);
    const ruleInfo = inject("ruleInfo");
    watchEffect(() => {
      console.log(ruleInfo.libraryIds);
      console.log(ruleInfo.followIds);
      if (ruleInfo.endDate || ruleInfo.startDate || ruleInfo.libraryIds || ruleInfo.followIds) {
        nextTick(() => {
          numberall();
        });
      }
    });
    const numberall = async () => {
      const res = await totalCount(ruleInfo);
      const resNum = await totalPersonNum(ruleInfo);
      data.count = res.data.value;
      data.personCount = resNum.data.value;
    };
    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#drugrightzero {
  width: 100%;
  height: 100%;
  @include flex-row-sa-c;
  .content-item {
    height: 100%;
    display: flex;
    align-items: center;
    .icon {
      font-size: 52px;
      margin-right: 16px;
    }
    .content-desc {
      height: 80%;
      @include flex-col-sa-s;
    }
  }
}
</style>
